<svg:path class="gauge-needle-point" [style.--angle]="angle" [attr.d]="needlePath"></svg:path>
<svg:circle [attr.cx]="center" [attr.cy]="center" [attr.r]="circleRadius"></svg:circle>
